import Phaser from "phaser";

import { KingdomLoadingScene } from "./KingdomLoadingScene";

export type KingdomLoadingRuntime = {
  game: Phaser.Game;
  scene: KingdomLoadingScene;
  ready: Promise<void>;
  destroy(): void;
};

export function createKingdomLoadingGame(
  parent: HTMLElement,
  reducedMotion: boolean,
): KingdomLoadingRuntime {
  const renderScale = Math.min(2, Math.max(1, window.devicePixelRatio || 1));
  const logicalWidth = Math.max(220, parent.clientWidth || 280);
  const logicalHeight = Math.max(170, parent.clientHeight || 214);
  let resolveReady: () => void = () => undefined;
  const ready = new Promise<void>((resolve) => {
    resolveReady = resolve;
  });
  const scene = new KingdomLoadingScene({ onReady: resolveReady }, reducedMotion, renderScale);
  const game = new Phaser.Game({
    type: Phaser.CANVAS,
    parent,
    width: Math.round(logicalWidth * renderScale),
    height: Math.round(logicalHeight * renderScale),
    transparent: true,
    backgroundColor: "rgba(0,0,0,0)",
    antialias: true,
    render: { antialias: true, pixelArt: false, roundPixels: false },
    scale: { mode: Phaser.Scale.NONE, autoCenter: Phaser.Scale.NO_CENTER },
    scene: [scene],
    banner: false,
  });
  const canvas = parent.querySelector("canvas");
  if (canvas !== null) {
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none";
    canvas.setAttribute("aria-hidden", "true");
  }
  const resizeObserver = typeof ResizeObserver === "undefined"
    ? null
    : new ResizeObserver(([entry]) => {
        if (entry === undefined) return;
        game.scale.resize(
          Math.round(Math.max(220, entry.contentRect.width) * renderScale),
          Math.round(Math.max(170, entry.contentRect.height) * renderScale),
        );
      });
  resizeObserver?.observe(parent);

  return {
    game,
    scene,
    ready,
    destroy(): void {
      resizeObserver?.disconnect();
      game.destroy(true);
    },
  };
}
